/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2019, Bulb Inc.  For more information, please email contact@hellobulb.com.
 *
 *  _            | | _
 * | |         _ | || |
 * | |__   _  | || || |__
 * | '_ \ | | | || || '_ \
 * | (_) || |_| || || (_) |
 *  \___/  \___/ |_| \___/
 *
 */

import { DisplayProps } from 'src/app/avatar/types';

/**
 * Class that encapsulates a family member. Fields include _id, displayName (that's all for now).
 */
export default class FamilyMember {
  private avatarURL: string;

  private displayProps: DisplayProps;

  public isButtonActive: boolean = false;

  constructor(
    avatarURL : string,
    displayProps: DisplayProps,
    isButtonActive: boolean = false,
  ) {
    this.avatarURL = avatarURL;
    this.displayProps = displayProps;
    this.isButtonActive = isButtonActive;
  }

  /**
   * Getter for member displayName.
   *
   * @return displayName
   */
  get getMemberDisplayName() : string {
    return this.displayProps.displayName;
  }

  /**
   * Getter for member username.
   *
   * @return username.
   */
  get getMemberUsername() : string {
    return this.displayProps.username;
  }

  /**
   * Getter for member id.
   *
   * @return _id.
   */
  get getMemberId() : string {
    return this.displayProps.id;
  }

  /**
   * Getter for members' avatar image.
   *
   * @return avatarURL.
   */
  get getMemberAvatarURL() : string {
    return this.avatarURL;
  }

  get getDisplayProps(): DisplayProps {
    return this.displayProps;
  }

  setButtonActive(status: boolean): void {
    this.isButtonActive = status;
  }
}
